(function completeTheLook() {
  var selectors = {
    section: "[id^='CompleteTheLookSection']",
    swiper: ".complete-the-look-swiper",
    navigation: "",
  };

  // CTL = Complete the Look
  let ctlSection = document.querySelectorAll(selectors.section);

  if (ctlSection.length == 0) {
    return;
  }

  ctlSection.forEach((ctl) => {
    const sectionId = ctl.dataset.sectionId;

    let slidesPerRow = ctl.dataset.slidePerRow || 4;
    let swiperOptions = {
      slidesPerView: 1.3,
      // Navigation arrows
      navigation: {
        nextEl: `[data-section-id="${sectionId}"] .swiper-button-next`,
        prevEl: `[data-section-id="${sectionId}"] .swiper-button-prev`,
      },
      // Responsive breakpoints
      breakpoints: {
        560: {
          slidesPerView: 2.2,
        },
        768: {
          slidesPerView: parseFloat(slidesPerRow),
        },
      },
    };

    new Swiper(
      `[data-section-id="${sectionId}"] ${selectors.swiper}`,
      swiperOptions
    );
  });
})();

(function (params) {
  // lightbox.option({
  //   'resizeDuration': 200,
  //   'wrapAround': true
  // })
})();

(function () {
  const selectors = {
    productSection: ".product-section",
  };

  const container = document.querySelector(selectors.productSection);

  container.addEventListener("variantPriceChange", function (event) {
    const variant = event.detail.variant;

    const selectors = {
      priceWrapper: "[data-product-price-wrap]",
      price: "[data-product-price]",
      comparePrice: "[data-compare-price]",
      savePrice: "[data-save-price]",
      priceA11y: "[data-a11y-price]",
      comparePriceA11y: "[data-compare-price-a11y]",
      inventoryStatus: ".product-block--sales-point",
    };

    var classes = {
      onSale: "on-sale",
      hidden: "hide",
    };

    let cache = {
      inventoryStatus: container.querySelector(selectors.inventoryStatus),
      priceWrapper: container.querySelectorAll(selectors.priceWrapper)[
        container.querySelectorAll(selectors.priceWrapper).length - 1
      ],
      comparePriceA11y: container.querySelectorAll(selectors.comparePriceA11y)[
        container.querySelectorAll(selectors.comparePriceA11y).length - 1
      ],
      comparePrice: container.querySelectorAll(selectors.comparePrice)[
        container.querySelectorAll(selectors.comparePrice).length - 1
      ],
      price: container.querySelectorAll(selectors.price)[
        container.querySelectorAll(selectors.price).length - 1
      ],
      savePrice: container.querySelectorAll(selectors.savePrice)[
        container.querySelectorAll(selectors.savePrice).length - 1
      ],
      priceA11y: container.querySelectorAll(selectors.priceA11y)[
        container.querySelectorAll(selectors.priceA11y).length - 1
      ],
      headerMobile: container.querySelector(
        ".product-block--header--mobile .product--price"
      ),
    };

    if (variant) {
      // Regular price
      cache.price.innerHTML = theme.Currency.formatMoney(
        variant.price,
        theme.settings.moneyFormat
      );
      cache.comparePrice.innerHTML = theme.Currency.formatMoney(
        variant.compare_at_price,
        theme.settings.moneyFormat
      );
      
      if(cache.headerMobile) {
        cache.headerMobile.innerHTML = theme.Currency.formatMoney(
          variant.price,
          theme.settings.moneyFormat
        );
      }
      // Sale price, if necessary
      if (variant.compare_at_price > variant.price) {
        const salePrice = theme.Currency.formatMoney(
          variant.compare_at_price,
          theme.settings.moneyFormat
        );
        if(cache.headerMobile) {
          cache.headerMobile.innerHTML = `
            <span class="visually-hidden">${theme.strings.salePrice}</span>
            ${theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)}
            <span class="visually-hidden">${theme.strings.regularPrice}</span>
            <s>${theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat)}</s>
          `;
        }
        
        cache.priceWrapper.classList.remove(classes.hidden);
        cache.price.classList.add(classes.onSale);
        cache.comparePriceA11y.setAttribute("aria-hidden", "false");
        cache.priceA11y.setAttribute("aria-hidden", "false");

        var savings = variant.compare_at_price - variant.price;

        if (theme.settings.saveType == "percent") {
          savings =
            Math.round((savings * 100) / variant.compare_at_price) + "%";
        } else {
          savings = theme.Currency.formatMoney(
            savings,
            theme.settings.moneyFormat
          );
        }

        cache.savePrice.classList.remove(classes.hidden);
        cache.savePrice.innerHTML = theme.strings.savePrice.replace(
          "[saved_amount]",
          savings
        );
      } else {
      
        if (cache.priceWrapper) {
          cache.priceWrapper.classList.add(classes.hidden);
        }
        cache.savePrice.classList.add(classes.hidden);
        cache.price.classList.remove(classes.onSale);
        if (cache.comparePriceA11y) {
          cache.comparePriceA11y.setAttribute("aria-hidden", "true");
        }
        cache.priceA11y.setAttribute("aria-hidden", "true");
      }

      // updating inventory
      const sectionId = event.target.dataset.sectionId;
      const productHandle = window.location.href
        .split("?")[0]
        .split("products/")
        .pop();
      
      const url = `/products/${productHandle}?variant=${variant.id}&section_id=${sectionId}`;

      fetch(url).then((res) =>
        res.text().then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const inventoryStatusSource = doc.body.querySelector(
            selectors.inventoryStatus
          );
          cache.inventoryStatus.innerHTML = inventoryStatusSource.innerHTML;
        })
      );
    }
  });
})();